import React, { useState } from 'react';
import { DocumentUploader } from './DocumentUploader';
import { DocumentTable } from './DocumentTable';
import { DocumentPreview } from './DocumentPreview';
import { UploadIcon, DownloadIcon, TrashIcon } from 'lucide-react';
import { useToast } from '../../context/ToastContext';
interface DocumentsSectionProps {
  applicationId: string;
}
export function DocumentsSection({
  applicationId
}: DocumentsSectionProps) {
  const {
    addToast
  } = useToast();
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [documents, setDocuments] = useState([{
    id: '1',
    type: 'Bank Statement',
    fileName: 'Meridian Savings L Scheer 5678 Oct24-Jan25.pdf',
    fileSize: 255.56,
    uploadedAt: new Date().toISOString(),
    verified: true,
    aiAnalysis: {
      institution: 'Meridian Financial Bank',
      account: '5678',
      keyPersons: ['Lucas Scheer'],
      dateRange: {
        start: '2024-10-01',
        end: '2025-01-31'
      },
      summary: 'High-Yield Savings account statement for Lucas Scheer from Meridian Financial Bank, account ending in 5678. The statement covers the period from October 1, 2024, to January 31, 2025, and shows a current balance of $45,892.45. A significant transaction includes a $30,000 transfer from an investment account on January 18, 2025.'
    }
  }, {
    id: '2',
    type: 'Pay Stub',
    fileName: 'Pay Stub Acme Corporation Lucas Scheer Jan 1-14 2025.pdf',
    fileSize: 2.28,
    uploadedAt: new Date().toISOString(),
    verified: true,
    aiAnalysis: {
      employer: 'Acme Corporation',
      keyPersons: ['Lucas Scheer'],
      dateRange: {
        start: '2025-01-01',
        end: '2025-01-14'
      },
      summary: 'Pay stub for Lucas Scheer from Acme Corporation for the period January 1-14, 2025. Gross pay: $3,846.15. Net pay: $2,851.22. YTD earnings: $3,846.15.'
    }
  }, {
    id: '3',
    type: 'Bank Statement',
    fileName: 'Meridian Checking Lucas Scheer 1234 Oct24-Jan25.pdf',
    fileSize: 328.37,
    uploadedAt: new Date().toISOString(),
    verified: true,
    aiAnalysis: {
      institution: 'Meridian Financial Bank',
      account: '1234',
      keyPersons: ['Lucas Scheer'],
      dateRange: {
        start: '2024-10-01',
        end: '2025-01-31'
      },
      summary: 'Checking account statement for Lucas Scheer from Meridian Financial Bank, account ending in 1234. The statement covers the period from October 1, 2024, to January 31, 2025, and shows a current balance of $12,459.78. Regular deposits from Acme Corporation appear on the 1st and 15th of each month.'
    }
  }]);
  const handleDocumentUpload = (files: File[]) => {
    // In a real app, this would upload the files to a server
    const newDocuments = files.map((file, index) => ({
      id: `new-${Date.now()}-${index}`,
      type: 'Unknown',
      fileName: file.name,
      fileSize: +(file.size / 1024).toFixed(2),
      uploadedAt: new Date().toISOString(),
      verified: false,
      aiAnalysis: null
    }));
    setDocuments([...documents, ...newDocuments]);
    addToast(`${files.length} document(s) uploaded successfully`, 'success');
  };
  const handleDocumentDelete = (documentId: string) => {
    setDocuments(documents.filter(doc => doc.id !== documentId));
    if (selectedDocument && selectedDocument.id === documentId) {
      setSelectedDocument(null);
    }
    addToast('Document deleted successfully', 'success');
  };
  const handleDocumentPreview = (document: any) => {
    setSelectedDocument(document);
  };
  const handleClosePreview = () => {
    setSelectedDocument(null);
  };
  const handleDownloadAll = () => {
    // In a real app, this would trigger downloads of all documents
    addToast('Downloading all documents...', 'info');
  };
  const handleDeleteAll = () => {
    // Show a confirmation dialog
    if (window.confirm('Are you sure you want to delete all documents? This action cannot be undone.')) {
      setDocuments([]);
      setSelectedDocument(null);
      addToast('All documents deleted successfully', 'success');
    }
  };
  return <div className="space-y-4" data-id="element-222">
      {selectedDocument ? <DocumentPreview document={selectedDocument} onClose={handleClosePreview} data-id="element-223" /> : <>
          <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden" data-id="element-224">
            <div className="flex items-center justify-between p-4 border-b border-neutral-200" data-id="element-225">
              <h2 className="text-xl font-medium text-neutral-900" data-id="element-226">
                Documents
              </h2>
              <div className="flex space-x-2" data-id="element-227">
                <button onClick={() => {}} // This would open a file upload dialog
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-228">
                  <UploadIcon className="mr-2 h-4 w-4" data-id="element-229" />
                  Upload
                </button>
                <button onClick={handleDownloadAll} className="inline-flex items-center px-3 py-2 border border-neutral-300 text-sm font-medium rounded-md bg-white text-neutral-700 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" disabled={documents.length === 0} data-id="element-230">
                  <DownloadIcon className="mr-2 h-4 w-4" data-id="element-231" />
                  Download All
                </button>
                <button onClick={handleDeleteAll} className="inline-flex items-center px-3 py-2 border border-danger-300 text-sm font-medium rounded-md bg-white text-danger-700 hover:bg-danger-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-danger-500" disabled={documents.length === 0} data-id="element-232">
                  <TrashIcon className="mr-2 h-4 w-4" data-id="element-233" />
                  Delete All
                </button>
              </div>
            </div>
            <div className="p-4" data-id="element-234">
              <DocumentUploader onUpload={handleDocumentUpload} data-id="element-235" />
            </div>
            {documents.length > 0 && <div className="p-4 pt-0" data-id="element-236">
                <DocumentTable documents={documents} onPreview={handleDocumentPreview} onDelete={handleDocumentDelete} data-id="element-237" />
              </div>}
          </div>
        </>}
    </div>;
}